import { Injectable } from '@angular/core';
import { AppCollection } from '../../app.config';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';
import { EditorJsonModel } from '../editor.json.model';

@Injectable({
  providedIn: 'root'
})
export class EditorService extends BaseCollectionService<EditorJsonModel, AppCollection> {
  protected ctor = EditorJsonModel;
}
